module.exports = __webpack_public_path__ + "static/media/gravitus-logo@3x.81c804ec.png";